// @ts-expect-error importing from JS file
import { OfflineEventTriggers, Networks } from 'AdsUI/lib/Constants';

/**
 * Determine if the event is a Facebook CAPI lifecycle stage event.
 * @param event Event from any network
 * @returns True or false
 */
export const isFacebookCapiLCSEvent = event => {
  return event.adNetwork === Networks.FACEBOOK && event.eventTriggerType === OfflineEventTriggers.LIFECYCLE_STAGE_CHANGE && !!event.installedPixelId;
};
/**
 * Determine if the event is a Facebook lifecycle stage event but does not use
 * CAPI.
 * @param event Event from any network
 * @returns True or false
 */

export const isNonCapiFacebookLCSEvent = event => {
  return event.adNetwork === Networks.FACEBOOK && event.eventTriggerType === OfflineEventTriggers.LIFECYCLE_STAGE_CHANGE && !event.installedPixelId;
};
/**
 * Get the subset of events that are Facebook CAPI lifecycle stage events.
 * @param events Events from any network
 * @returns A subset of `events`
 */

export const getFacebookCapiLCSEvents = events => events.filter(event => isFacebookCapiLCSEvent(event));
/**
 * Get the subset of events that are Facebook lifecycle stage events but do not
 * use CAPI.
 * @param events Events from any network
 * @returns A subset of `events`
 */

export const getNonCapiFacebookLCSEvents = events => events.filter(event => isNonCapiFacebookLCSEvent(event));
/**
 * Get the ad account that the event belongs to.
 * @param event An existing event
 * @param availableAdAccounts Ad accounts available to the user
 * @returns The ad account that contains the event
 */

export const getEventAdAccount = (event, availableAdAccounts) => {
  if (!event) {
    return null;
  }

  return availableAdAccounts.get(event.adNetwork).find(account => account.accountId === event.accountId);
};
/**
 * Get the lifecycle stages available for new events to be created with the
 * given ad account.
 * @param allLifecycleStages All lifecycle stages
 * @param usedLifecycleStagesByAccount Mapping of ad account to used lifecycle stages
 * @param adAccount The ad account whose lifecycle stages we're interested in
 * @param eventToReplace The event that the user wants to replace
 * @returns The lifecycle stages available for new events to be created with the given ad account
 */

export const getAvailableLifecycleStages = (allLifecycleStages, usedLifecycleStagesByAccount, adAccount, eventToReplace) => {
  const usedLifecycleStages = usedLifecycleStagesByAccount.get(adAccount).toArray();

  if (!usedLifecycleStages.length) {
    return allLifecycleStages;
  }

  const availableStages = allLifecycleStages.filter(lifecycleStage => !usedLifecycleStages.includes(lifecycleStage));

  if (eventToReplace) {
    availableStages.push(eventToReplace.stageId);
  }

  return availableStages;
};
/**
 * Get the event's pixel from the list of installed pixels.
 * @param event
 * @param installedPixels
 * @returns The found pixel or undefined
 */

export const getEventPixel = (event, installedPixels) => installedPixels.find(pixel => pixel.installed && pixel.adNetwork === event.adNetwork && pixel.accountId === event.accountId && pixel.id === event.setId);